var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatencyTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.7,207.7c-33.4,0-60.5-27.2-60.5-60.5s27.2-60.5,60.5-60.5s60.5,27.2,60.5,60.5S293.1,207.7,259.7,207.7z  M259.7,102.2c-24.8,0-45,20.2-45,45s20.2,45,45,45s45-20.2,45-45S284.5,102.2,259.7,102.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397,291.5c-2.3,0-3.9-0.8-5.4-2.3c-3.1-3.1-3.1-7.8,0-10.9c34.9-34.9,54.3-81.5,54.3-131.1 S426.5,51,391.6,16.1c-3.1-3.1-3.1-7.8,0-10.9c3.1-3.1,7.8-3.1,10.9,0c38,37.2,59,87.7,59,141.2s-20.9,104.7-59,142.7 C400.9,290.7,399.3,291.5,397,291.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.4,291.5c-2.3,0-3.9-0.8-5.4-2.3C38.6,210.8,38.6,82.8,117,4.5c3.1-3.1,7.8-3.1,10.9,0s3.1,7.8,0,10.9 c-72.1,72.1-72.1,190.8,0,263c3.1,3.1,3.1,7.8,0,10.9C126.3,290.7,124.7,291.5,122.4,291.5L122.4,291.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.4,259.7c-2.3,0-3.9-0.8-5.4-2.3c-3.1-3.1-3.1-7.8,0-10.9c55.1-55.1,55.1-144.3,0-199.4 c-3.1-3.1-3.1-7.8,0-10.9c3.1-3.1,7.8-3.1,10.9,0c61.3,61.3,61.3,160.6,0,221.1C368.3,258.9,366.8,259.7,364.4,259.7L364.4,259.7 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155,259.7c-2.3,0-3.9-0.8-5.4-2.3c-61.3-61.3-61.3-160.6,0-221.1c3.1-3.1,7.8-3.1,10.9,0s3.1,7.8,0,10.9 c-55.1,55.1-55.1,144.3,0,199.4c3.1,3.1,3.1,7.8,0,10.9C158.8,258.9,157.3,259.7,155,259.7L155,259.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.6,227.9c-2.3,0-3.9-0.8-5.4-2.3c-3.1-3.1-3.1-7.8,0-10.9c37.2-38,37.2-98.5,0-135.8 c-3.1-3.1-3.1-7.8,0-10.9c3.1-3.1,7.8-3.1,10.9,0c42.7,42.7,42.7,114,0,157.5C336.5,227.1,334.9,227.9,332.6,227.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.8,227.9c-2.3,0-3.9-0.8-5.4-2.3c-42.7-42.7-43.4-114,0-157.5c3.1-3.1,7.8-3.1,10.9,0s3.1,7.8,0,10.9 c-37.2,38-37.2,98.5,0,135.8c3.1,3.1,3.1,7.8,0,10.9C190.7,227.1,189.1,227.9,186.8,227.9L186.8,227.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.7,418.7H162.7c-3.1,0-5.4-1.6-7-3.9c-1.6-2.3-1.6-5.4,0-7.8l97-167.6c3.1-4.7,10.9-4.7,13.2,0l97,167.6 c1.6,2.3,1.6,5.4,0,7.8C362.1,417.2,359.8,418.7,356.7,418.7z M175.9,403.2h166.8l-83-144.3L175.9,403.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.7,390.8c-4.7,0-7.8-3.1-7.8-7.8s3.1-7.8,7.8-7.8c4.7,0,7.8,3.1,7.8,7.8v0.8 C267.5,387.7,264.4,390.8,259.7,390.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.7,369.9c-4.7,0-7.8-3.1-7.8-7.8v-57.4c0-4.7,3.1-7.8,7.8-7.8c4.7,0,7.8,3.1,7.8,7.8v57.4 C267.5,366.8,264.4,369.9,259.7,369.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238,288.4c-4.7,0-7.8-3.1-7.8-7.8v-85.3c0-4.7,3.1-7.8,7.8-7.8c4.7,0,7.8,3.1,7.8,7.8v85.3 C245.7,285.3,242.6,288.4,238,288.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.4,288.4c-4.7,0-7.8-3.1-7.8-7.8v-85.3c0-4.7,3.1-7.8,7.8-7.8s7.8,3.1,7.8,7.8v85.3 C289.2,285.3,286.1,288.4,281.4,288.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.4,466.8c-4.7,0-7.8-3.1-7.8-7.8V411c0-4.7,3.1-7.8,7.8-7.8s7.8,3.1,7.8,7.8v48.1 C289.2,463.7,286.1,466.8,281.4,466.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238,466.8c-4.7,0-7.8-3.1-7.8-7.8V411c0-4.7,3.1-7.8,7.8-7.8c4.7,0,7.8,3.1,7.8,7.8v48.1 C245.7,463.7,242.6,466.8,238,466.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.9,498.6H94.5c-11.6,0-21.7-10.1-21.7-21.7v-4.7c0-11.6,10.1-21.7,21.7-21.7h329.7 c11.6,0,21.7,10.1,21.7,21.7v4.7C445.9,488.5,436.6,498.6,424.9,498.6z M94.5,466c-3.1,0-6.2,3.1-6.2,6.2v4.7 c0,3.1,3.1,6.2,6.2,6.2h330.5c2.3,0,5.4-2.3,5.4-6.2v-4.7c0-3.1-3.1-6.2-6.2-6.2H94.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatencyTesting);
export default __webpack_public_path__ + "static/media/Latency Testing.55a735220e55e7cd98f6852edbead377.svg";
export { ForwardRef as ReactComponent };